import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { deleteExpenditure } from '../../../../../Redux/expenses/expensesSlice'

const ViewChanges = ({ close, data }) => {
  const { t } = useTranslation() || ((text) => text)
  const dispatch = useDispatch()
  const { type } = data || {}
  const { expenses } = useSelector((state) => state.expenses)
  const [searchTerm, setSearchTerm] = useState('')

  const translateCategory = (category) => {
    const categoryMap = {
      'Food': 'Ushqimi',
      'Material': 'Materiali',
      'Tech': 'Tekniku',
      'Other': 'Tjera'
    }
    return categoryMap[category] || category
  }

  // Expense-only modal (cash register history uses ViewCashierHistory)
  const changes = type === 'expense' ? (expenses ?? []) : []

  const sortedChanges = [...changes].sort((a, b) => {
    const aTime = a.createdAt ? new Date(a.createdAt) : new Date(a.date)
    const bTime = b.createdAt ? new Date(b.createdAt) : new Date(b.date)
    return bTime - aTime
  })

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  const formatTime = (timestamp) => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    if (isNaN(date.getTime())) return ''
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${hours}:${minutes}`
  }

  const filteredChanges = sortedChanges.filter((change) => {
    const searchLower = searchTerm.toLowerCase()
    const description = change.description?.toLowerCase() || ''
    const category = change.category?.toLowerCase() || ''
    const amount = String(change.paid_amount || '')
    const date = formatDate(change.date).toLowerCase()
    return (
      description.includes(searchLower) ||
      category.includes(searchLower) ||
      amount.includes(searchLower) ||
      date.includes(searchLower)
    )
  })

  const handleDelete = (change) => {
    dispatch(deleteExpenditure({ id: change.id }))
  }

  const totalAmount = filteredChanges.reduce((sum, change) => sum + Number(change.paid_amount || 0), 0)

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.popup_header}>
        <h2>Ndryshimet e Shpenzimeve</h2>
        <div className={styles.header_controls}>
          <div className={styles.search_container}>
            <input
              type="text"
              placeholder="Kërko..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.search_input}
            />
          </div>
          <button className={styles.close_btn} onClick={close}>
            ✖
          </button>
        </div>
      </div>
      <div className={styles.summary_section}>
        <div className={styles.summary_item}>
          <span className={styles.summary_label}>Totali i Regjistrimeve</span>
          <span className={styles.summary_value}>{filteredChanges.length}</span>
        </div>
        <div className={styles.summary_item}>
          <span className={styles.summary_label}>Shuma Totale</span>
          <span className={styles.summary_value}>€ {totalAmount.toFixed(2)}</span>
        </div>
      </div>
      <div className={styles.popup_body}>
        <div className={styles.changes_list}>
          {filteredChanges.map((change, index) => (
            <div key={change.id || index} className={styles.change_item}>
              <div className={styles.change_main}>
                <div className={styles.change_date}>
                  📅 {formatDate(change.date)}
                  {change.createdAt && formatTime(change.createdAt) && (
                    <span className={styles.change_time}>
                      🕐 {t('time')}: {formatTime(change.createdAt)}
                    </span>
                  )}
                </div>
                <div className={styles.change_description}>
                  {change.description || translateCategory(change.category)}
                </div>
                {change.description && (
                  <div className={styles.change_category}>
                    Kategoria: {translateCategory(change.category)}
                  </div>
                )}
              </div>
              <div className={styles.change_actions}>
                <div className={styles.change_amount}>
                  € {change.paid_amount}
                </div>
                <button
                  className={styles.delete_button}
                  onClick={() => handleDelete(change)}
                  title="Fshi"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
          {filteredChanges.length === 0 && (
            <div className={styles.no_changes}>
              {searchTerm ? 'Nuk u gjetën rezultate' : 'Nuk ka ndryshime'}
            </div>
          )}
        </div>
      </div>
      <div className={styles.popup_footer}>
        <button onClick={close} className={styles.close_button}>
          Mbyll
        </button>
      </div>
    </div>
  )
}

ViewChanges.propTypes = {
  close: PropTypes.func.isRequired,
  data: PropTypes.shape({
    type: PropTypes.oneOf(['expense'])
  })
}

export default ViewChanges
